// extracted by mini-css-extract-plugin
export default {"modal":"ModalComponent_modal__OOj0W","isActive":"ModalComponent_isActive__kBm-s","back":"ModalComponent_back__xlODV","title":"ModalComponent_title__40MU4"};